import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { APY_EFFECTIVE_DATE, APY } from '../consts'
// i18n configuration
Vue.use(VueI18n)

export const messages = {
  en: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
      },
      noDataText: '',
    },
    userMessage: {
      emailExist: {
        title: 'Looks like you׳re one of us',
        content:
          'You already have an account under this Email. Log into your Lili app now using this Email, or choose a different Email.',
        cta: 'Log in',
      },
      tokenExpire: {
        title: 'It seems we have to start again',
        content:
          'Your session has expired in order to keep your personal details safe',
        cta: 'Continue',
      },
      howDidYouHear: {
        title: 'What brings you to open an account today?',
        cta: 'Continue',
        cancel: 'Cancel',
      },
      reviewDetails: {
        title: 'Please review your details',
        content: 'Double-check yourself, so we don׳t have to!',
        cta: 'Have another look',
      },
      downloadLili: {
        title: 'You haven׳t installed Lili yet',
        content: 'Download the app first, then we can get down to business!',
        cta: 'Download now',
      },
      textLink: {
        title: 'We sent it 💬',
        content_a: 'We just sent you a text message to',
        content_b: 'Tap the link in the text to get started.',
        cta: 'Got It',
        resend: 'Resend Code',
        resend_active_a: 'We can resend the code in',
        resend_active_b: 'seconds',
      },
      notFreelancer: {
        title: 'No business? No problem.',
        content:
          'If you’re self-employed, a sole proprietor or an independent worker, a small business owner or a side hustler then <br /> <b> Lili got you covered!</b>',
        cta: 'Let’s Continue',
      },
      redirectOutsideWarning: {
        title: 'Please Note',
        content:
          'You have clicked on a link that will take you out of the Lili app',
        cancel: 'Stay Here',
        continue: 'Continue',
        disclaimer:
          'Lili and its sponsor bank do not endorse/guarantee, and are not liable for the failure of, the products/services advertised on the linked site. See the Privacy Notice on that site about treatment of your personal information.',
      },
    },
    template: {
      restart: 'Start Over',
      website: 'Our Website',
      faq: 'FAQ',
      dialogTitle: 'Are you sure?',
      dialogBody:
        'In order to keep your information secure, you can’t go backward in the registration process. By clicking “back", you’ll have to start the process again from the start.',
      dialogContinue: 'No, I want to continue',
      dialogRestart: 'Yes, I want to start again',
      timeoutTitle: 'Oh uh, it seems we have to start again',
      timeoutBody:
        'Your session has expired. In order to keep your personal details safe, you’ll need to restart the registration process',
      timeoutButton: 'Ok, let’s go',
    },
    howDidYouHear: {
      mainHeader: 'What’s your main reason for opening a business account?',
      reasonForOpen: {
        justStarted:
          'Recently started my business and I am ready to get set up',
        organizing:
          'Moving my business from my personal to a dedicated business account',
        unhappy: 'Unhappy with my current bank and want a better option',
        loan: 'Need a business account to apply for a loan',
        onePlace:
          'Your all-in-one banking, accounting, and tax tools fit my business needs',
        other: 'Other',
      },
    },
    review: {
      mainHeader: 'Confirm your details',
      contact: 'Contact',
      phone: 'Phone number',
      address: 'Home address',
      id: 'Identity',
      type: 'Account type',
      goSmart: 'Go Smart',
    },
    accountTypeV3: {
      mainHeader: 'Choose a plan',
      backBtn: 'Back',
      cardHeaderPromotion: 'Most Popular',
      becomeAVip: 'Become a VIP',
      disclaimer:
        '<span style="font-size: 10px">1. </span> BalanceUp is a discretionary overdraft program for debit card purchases only, offered for Lili Pro, Lili Smart, and Lili Premium Account holders. You must meet eligibility requirements and enroll in the program. Once enrolled, your Account must remain in good standing with a deposit and spending history that meets our discretionary requirements to maintain access to the feature. BalanceUp overdraft limits of $20-$200 are provided at our sole discretion, and may be revoked any time, with or without notice.',
      disclaimer_2: `<span style="font-size: 10px">2. </span> The Annual Percentage Yield (“APY”) for the Lili Savings Account is variable and may change at any time. The disclosed APY is effective as of ${APY_EFFECTIVE_DATE}. Must have at least $0.01 in savings to earn interest. The APY applies to balances of up to and including $1,000,000. Any portions of a balance over $1,000,000 will not earn interest or have a yield.`,
      disclaimer_3:
        '<span style="font-size: 10px">3. </span> Lili’s Talk to a CPA is a service that provides Premium plan customers access to a certified public accountant for 30 minutes every three months. Lili is not a tax preparer and does not provide tax, legal or accounting advice. This is a limited time pilot that may be cancelled at any time.',
      tabs: {
        premium: 'Premium',
        smart: 'Smart',
        pro: 'Pro',
        basic: 'Basic',
      },
      ctas: {
        select: 'Select',
        tryForFree: 'Try 30 Days for Free',
      },
      badge: '30 Days Free Trial',
      planMinDeposit: '$0 Minimum Deposit',
      planHighlightsTitle: 'Plan Highlights:',
      premium: {
        title: 'Lili Premium',
        promotion:
          'Our preferred plan to manage your business with full bookkeeping and tax software. Exclusive benefits including a Metal card and priority support',
        promotion_CPA:
          'Our preferred plan to manage your business with full bookkeeping and tax software.\n' +
          'Exclusive benefits including a Metal card, CPA and priority support',
        deposit: '$0 Minimum Deposit',
      },
      smart: {
        title: 'Lili Smart',
        promotion:
          'The smartest plan for small business owners. Accounting, taxes, and banking — all in one platform',
      },
      pro_v2: {
        title: 'Lili Pro',
        promotion:
          'An advanced business account that takes care of your day-to-day finances',
      },
      basic_v2: {
        title: 'Lili Basic',
        promotion: 'A basic banking solution for your small business needs',
      },
      highlights: {
        shared: {
          a: 'Advanced Business Checking Account',
          b: 'Lili Visa® Debit Card with Cashback Awards through Visa SavingsEdge',
          c: 'Fee-free ATM withdrawals at 38K locations',
          d: 'Get paid up to 2 days early',
          e: 'Automatic Tax Savings',
          f: 'Fee-free Overdraft up to $200<sup>1</sup>',
          g: `${APY}% APY<sup>2</sup> on Savings`,
          premierPrioritySupport: {
            title: 'Premier Priority Service',
            content:
              'Front of the line experience with priority support and a dedicated account specialist',
          },
          smartBookkeeping: {
            title: 'Smart Bookkeeping',
            content:
              'Smart Bookkeeping Instantly sort your income and expense transactions into tax categories to simplify tax preparation. Attach your receipts, add notes, and generate financial reports',
          },
          billPay: {
            title: 'Bill Pay Solution',
            content:
              'Scan your bills, manage your vendors, pay instantly & directly from your account',
          },
          unlimitedInvoices: {
            title: 'Unlimited Invoices and Payments',
            content:
              'Easily create and send professional invoices, accept payments instantly, track invoices and send reminders',
          },
          taxReports: {
            title: 'Tax Forms 1065/1120-S/Schedule C',
            content:
              'Maximize your tax refund with pre-filled business tax forms',
          },
        },
        premium: {
          metalCard:
            'Lili Visa® Debit Card - Metal with Cash Back Awards through Visa SavingsEdge',
        },
        pro_v2: {
          expenseManagement: {
            title: 'Expense Management Tools & Reports',
            content:
              'Organize your expense transactions into tax categories. Attach your receipts, add notes, and Easily generate quarterly and annual expense reports',
          },
        },
        basic_v2: {
          a: 'Business Checking Account',
          b: 'Visa® Business debit card',
          c: 'Fee-free ATM withdrawals at 38K locations',
          d: 'Get paid up to 2 days early',
          e: 'Automatic Savings',
        },
      },
    },
    accountType: {
      mainHeader: 'Choose a plan',
      cta: 'Choose a plan',
      pro: {
        title: 'Lili Pro',
        subTitle: 'Cancel anytime',
        plan: '$9.00 / Month',
        footer: 'RECOMMENDED',
        a: 'Premium Visa Business debit card with cash-back rewards',
        b: 'Advanced Write-Off Tracker',
        c: 'Automatically save for taxes',
        d: 'Schedule C Generator and quarterly expense report',
        e: 'Invoicing Software',
        f: `Savings Account with ${APY}% APY`,
        g: 'Fee-Free Overdraft up to $200*',
        h: 'No minimum balance requirement',
      },
      standard: {
        title: 'Lili Standard',
        subTitle: 'Free',
        plan: '$0.00 / MONTH',
        a: 'Visa Business debit card',
        b: 'Basic Write-Off Tracker',
        c: 'Receipt Scanner',
        d: 'Automatically save for taxes',
        e: 'Quarterly Expense Report',
        f: '38,000+ fee-free ATM locations',
        g: 'No monthly fee, no minimum balance',
        h: 'Get paid faster with direct deposit',
      },
    },
    accountTypeV2: {
      mainHeader: 'Select a plan',
      cta: 'CHOOSE PLAN',
      pro: {
        title: 'Lili Pro',
        subTitle: '$0 Minimum deposit',
        plan: '$9.00 / Month',
        badgeContent: 'RECOMMENDED',
        sectionHeader: {
          a: 'Lili Pro checking',
          b: 'Tax optimizer',
          c: 'DIY accounting',
        },
        a: 'Visa business debit + cash back rewards',
        b: 'Fee-free ATM at 38K locations',
        c: 'Get paid 2 days early',
        d: 'Fee-free overdraft up to $200*',
        e: `${APY}% APY* on savings`,
        g: 'Real-time write-off tracker',
        h: 'Automatic tax savings',
        i: 'Schedule C generator',
        j: 'Invoicing software',
        k: 'Receipt scan & save',
        l: 'Automatic business reports',
      },
      standard: {
        title: 'Lili Basic',
        subTitle: 'Free',
        plan: '$0.00 / Month',
        sectionHeader: {
          a: 'Lili basic checking',
          b: 'Expense categorization',
          c: 'Quarterly expense reports',
        },
        a: 'Visa business debit',
        b: 'Fee-Free ATM at 38K locations',
        c: 'Get paid 2 days early',
      },
    },
    welcome: {
      heading: 'Banking Designed for Freelancers.',
      line1: 'Tailor-made to help you balance Work & Life. 100% free. No Fees.',
      line2: 'Four simple steps, and you’ll have Lili in your corner.',
      button: 'Sign me up',
      sendButton: 'Sign me up',
      existingAccount: 'Already have an account?',
      dialogTitle: 'Got a Lili invite code?',
      dialogBody: 'Enter the invite code you received in the mail',
      getACode: "I didn't get a code. Please send me one",
      unknownCode: "Sorry but we don't know this code",
    },
    notice: {
      title: '<h2 class="main-header" >Welcome to Lili, </h2>',
      headerLine2: 'One platform for your business finances.',
      headerLine2PartnerView: 'Powering your business growth',
      line1:
        "Let's open your business checking account. A few simple steps and you're in business!",
      details1: 'Complete your application',
      details2: 'Download the Lili app',
      details3: 'Pair your device',
      details4: 'Get your Lili Visa card',
      submit: 'Continue',
      notAFreelancer: 'I Don׳t Have a Business',
    },
    business: {
      title: 'Tell us about your business...',
      titleGeneral: `What's your speciality? 💪`,
      defaultSelection: 'What׳s your industry?',
      defaultSelectionGeneral: `I'm a freelancer in...`,
      defaultQuestionB: 'What׳s your business entity?',
      desclaimer:
        'You’ll be able to add your DBA or LLC information in the Lili app once you complete sign up',
      llcDesclaimer:
        'You will need to upload your <b> IRS Employment Identification Number </b> (EIN) letter in the Lili app once your account is opened.',
      dbaDesclaimer:
        'You will need to upload your DBA documentation in the Lili app once your account is opened.',
      requiredDocsTitle: 'Please prepare one of the following documents:',
      docsTypes: {
        llc: {},
        dba: {
          a: 'DBA Registration Form or Fictitious Name Registration',
          b: 'or Assumed Name Certificate',
        },
      },
    },
    intro: {
      title: 'Your personal details',
      subHeader: 'Please enter your name as it appears in legal documents.',
      viewTitle: 'contact',
      submit: 'Continue',
      segment: 'I’m a freelance...',
      segmentOther: 'So what do you do?',
      notFound: 'Other',
      referralCode: 'Add a referral code',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      referral: 'Referral Code',
      password: 'Create Password',
      loginPassword: 'Password',
    },
    contact: {
      title: 'Your mobile number',
      subHeader:
        'Your account is protected using Two-Factor authentication with your mobile number.',
    },
    register: {
      title: 'Verification',
      label: 'Mobile number',
      chat2:
        'Thanks {name}. Next, let’s verify your <span style="font-family: MetricBold">mobile</span> phone number',
      submit: 'Send code',
    },
    pinCodeValidation: {
      title: 'Verification',
      message:
        'We’ve sent your <span style="font-family: MetricBold">verification code</span> to {phone}',
      chatResend:
        'Didn’t get your verification code yet? Let us send it to you again',
      resend: 'Resend verification code',
      label: 'Verification Code',
      resendMessage:
        'Your verification code was just re-sent. We can send a new code in {time} seconds.',
    },
    password: {
      chat2:
        'It’s <span style="font-family: MetricBold">password</span> time! 🔒',
      field1: 'Secure and memorable password',
      req1: '8 characters or more',
      req2: 'At least one symbol',
      req3: 'At least one uppercase letter',
      req4: 'At least one number',
      req5: 'At least one lowercase letter',
      req6: 'No obvious character sequences',
      req7: 'At least one capital',
      req8: 'At least one lowercase letter',
      req9: 'At least one number',
      req10: 'No sequential characters',
    },
    kyc: {
      chat2: 'Personal identity verification',
      subTitle:
        'This is a federal requirement, but <span style="font-family: MetricMedium; font-weight: normal">it won\'t have any impact </span> on your credit score.',
      footer:
        'At the moment, Lili accounts can only be created with an SSN. We’re aren’t able to create accounts for EINs yet, but stay tuned!',
      tooltip: 'Don’t worry, this connection is secured and the data encrypted',
      title: 'Account set-up',
      ssn: 'Social security number',
      birthDate: 'Date of birth',
      submit: 'Continue',
    },
    address: {
      title: 'Account set-up',
      address: 'Find your address',
      chat2:
        'We’re almost there! Please enter your home address, so we know where to send your new debit card.',
      apartment: 'Apartment/Suite Number',
      notFound: 'We can’t find your address. Let’s try again',
      foundWrong: "Not you'r address? Click to enter it manually",
    },
    addressDetail: {
      title: 'Address',
      message: 'Your home address',
      line1: 'Address (no P.O box)',
      line2: ' Apt/Suite (optional)',
      city: 'City',
      state: 'State',
      postalCode: 'Zip code',
      postalOrZipCode: 'Zip / Postal code',
    },
    confirmDetails: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'E-mail',
      phone: 'Phone Number',
      ssn: 'SSN',
      birthDate: 'Birth Date',
      address: 'Address',
      apartment: 'Apartment/Suite',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      chat2:
        'Please review all of your information again to make sure everything is accurate and up-to-date',
    },
    tnc: {
      chat2:
        'Last thing, please review and confirm the following details and our <span style="font-family: MetricBold">terms and conditions</span>',
      title:
        'Please read and <span style="font-family: MetricBold">accept</span> our',
      url: 'Terms & Conditions',
      checkbox: 'I have read and accept Lili’s T&C',
      visaCheckbox:
        "I have read and accept Visa's SavingsEdge Terms and Conditions",
      accept: 'Finish',
      declineText:
        "We can't continue. To open a lili account, you have to accept the terms and conditions.",
      tncTitle: 'Lili Account Agreement Terms and Conditions',
      tncOK: 'Close',
    },
    confirm: {
      title: 'Final review',
      tnc: 'Terms & Conditions',
      checkbox: 'I have read and agree to the',
      contact: 'Contact',
      address: 'Address',
      identity: 'Identity',
      accept: 'Apply',
      edit: 'Edit',
      declineText:
        "We can't continue. To open a lili account, you have to accept the terms and conditions.",
      tryAgain: 'Please wait for 30 seconds and try again',
      failedKycResubmit:
        "We can't ship a card to a PO Box or a non residential address",
    },
    approved: {
      title: ', your Lili digital card is ready to go',
      subHeader: {
        unknown:
          'Your physical card will arrive within 2 weeks, meanwhile log in to the app to start using your digital card online or in-store.',
        android:
          'Your physical card will arrive within 2 weeks, meanwhile log in to the app to start using your digital card online or in-store using G Pay.',
        ios: 'Your physical card will arrive within 2 weeks, meanwhile log in to the app to start using your digital card online or in-store using Apple Pay.',
      },
      cardNumber: '---- ---- ---- ----',
      cta: 'See My Card Details',
    },
    continue: {
      title: 'Welcome back! Let’s pick up where we left off!',
      text: 'Start by entering your password and the security code you should be receiving by text in the next few seconds',
      validationCode: 'Verification Code',
      password: 'Enter password',
    },
    sorry: {
      title: 'So sorry, we’re not ready for you (yet!)',
      line1:
        'This isn’t the end though. Let’s stay in touch, and we’ll let you know as soon as we can accommodate your needs.',
      reasonIphone: 'I don’t have an iPhone',
      reasonBusiness: 'I’m not a freelancer',
    },
    stopNoBusinessDone: {
      title: 'We’re sorry',
      line1:
        'Lili is designed specifically for independent workers and small business owners. ',
    },
    stopNoIphoneDone: {
      title: 'Thank you, we’ll stay in touch',
      line1:
        'We’ll let you know as soon as our version for Android is up and running!',
    },
    success: {
      title: 'Time to move to the Lili app.',
      line1:
        'Finish setting up your account, and start spending right now online and in-store (using Apple or Google Pay) with your digital card.',
      details1: 'No hidden fees',
      details2: 'No Minimum Balance',
      details3: 'Early Payment with Direct Deposit',
      details4: 'Free Expense Management',
      details5: 'Auto-Savings Buckets',
      downloadMobile: 'Download the Lili app',
      loginMobile: 'Login',
      downloadDesktop: 'Text me the link',
      alreadyHave: 'I already have the app',
      conditions:
        'Bank Account Services provided through our partner bank Choice Financial Group; Member FDIC',
    },
    exists: {
      title: 'Hi there, already have an account?<br/>That’s awesome.',
      line1:
        'If you’re already a member of Lili banking, just download the app and you’re all set-up 🤙🏽',
      line2: 'Not a member yet? That’s OK! ',
      signUp: 'Sign-up here',
    },
    no_kyc: {
      title: 'Hmm, we’ve hit a snag.',
      line1: 'Please contact Lili customer service to complete your sign up.',
      line2: 'Call us at (855) 545-4380',
    },
    no_kyc_deceased: {
      title: "We're sorry!",
      line1:
        "Based on the information you provided, we're unfortunately not able to open a Lili account at this time. For privacy and security reasons, our support team can't provide you with any further information.",
      line2: 'We thank you again for your interest in Lili.',
    },
    no_kyc_more_info: {
      title: 'One last step',
      line1:
        'We just need to verify a couple of things before we can create your Lili account.',
      line2:
        '<ul><li>Valid Driver’s License (current, unexpired)</li><br/>' +
        '<li>Valid federal or state issued ID (current ,unexpired)</li><br/>' +
        '<li>Mortgage statement</li><br/>' +
        '<li>Lease agreement (negotiated within the last 6 months)</li><br/>' +
        '<li>Utility bill (dated within the last 60 days)</li><br/></ul>' +
        'We can’t wait to have you on board, so as soon as we get your document we’ll wrap this up, and then there’ll be no stopping us!',
    },
    no_kyc_list: {
      title: 'Hang tight!',
      line1:
        'You’re all done! <br> We’re reviewing your application, and will get back to you shortly!',
    },
    kyb_pending: {
      title: "You're almost there!",
      titlePollingFalse: 'Stay tuned!',
      line1:
        "We're reviewing your application - this will take less than a minute",
      line2: 'Thank you for submitting your application to Lili.',
      line3:
        'We’re reviewing your application, and will get back to you within the next 1-2 business days.',
    },
    verification_center: {
      title: 'Verify your business',
    },
    notFound: {
      title: 'Oops, we are lost.',
      line1: 'We’re sorry for the inconvenient, the page cannot be found 🤷🏾‍♀️',
      button: 'Take me home',
    },
    login: {
      title: 'Please enter your password to continue the onboarding process',
      chat2:
        'Happy you came back to finish the onboarding. Please enter your password',
    },
    errors: {
      voip: 'Sorry but Lili doesn’t support virtual phone numbers. Please enter a direct mobile to proceed.',
      landline:
        'We like that you’re old school and still use a landline! But we need a mobile phone number to open your Lili account. 😉',
      oops: 'Shoot, we’re having some technical issues. Please try again later or contact us at <a target="_blank" href="mailto:support@lili.co">support@lili.co</a>',
      alreadyHasAnAccount:
        'We already have an account for this Phone number. Log into the app now or use a different Phone number.',
      emailExists:
        'An account with this email already exists. Please login directly from the Lili app.',
      tokenTimeout:
        'We waited forever for you! re-enter your mobile for new verification',
      badPasswordToken:
        'Avoid using 3 identical characters in a row for your password',
      tooBig: 'Maximum document size is 15MB',
      notUsNumber:
        'We’re sorry, but you can only use a US phone number to open a Lili account.',
    },
    uploadAuto: {
      title: 'One last step',
      cta: 'TEXT ME THE LINK',
      line1:
        'We just need to verify a couple of things before we can create your Lili account.',
      line2: 'We will send you a text with a link to upload the following:',
      iconBox1: { title: 'Identification document', content: 'Front and back' },
      iconBox2: { title: 'Close up selfie', content: 'Face only' },
      iconBox3: { title: `Arm׳s length selfie`, content: 'Shoulders up' },
    },
    upload: {
      title: 'One last step',
      line1:
        "We're almost there! We just need to verify some additional information so we can finish creating your Lili account. Please upload the following documents",
      submit: 'Continue',
      subtitle1: 'Upload Your ID',
      uploadLabel1: 'Choose a document to upload',
      details1:
        'Valid driver’s license or valid federal or state issued ID (unexpired)',
      subtitle2: 'Proof of Address',
      uploadLabel2: 'Choose a document to upload',
      details2:
        'Mortgage statement, lease agreement and utility bill (gas, electric, internet - from the last 60 days)',
      required: 'File is required',
    },
    debit_card_name: {
      title:
        "{name}, you have a lovely name, but it is a bit long and won't fit on our debit card. ",
      titleNoName:
        "You have a lovely name, but it is a bit long and won't fit on our debit card. ",
      line1: 'It won’t fit on your debit card.',
      line2:
        'Unfortunately, your card can only fit the first 20 characters of your name, is there a shorter version we can use?',
      firstName: 'Your shortened first name',
      lastName: 'Your shortened last name',
      mainHeader: ' , you have a lovely name, but it’s a bit long',
    },
    upload_complete: {
      title: "You're all done {name}!",
      line1:
        'We will review your documents and we’ll let you know once it’s approved.',
    },
    validation: {
      general: {
        noEmpty: "Text can't be empty",
      },
      custom: {
        email: {
          required: 'Email is required',
          email: 'What is this email format? 🤔',
          exists:
            'We already have an account for this Email. Log into the app now using your Email or use a different Email.',
        },
        segment: {
          required:
            'Please tell us what kind of work you do in order to continue.',
        },
        referral: {
          invalid: 'Invalid referral code.',
          expired:
            'Sorry, this referral program has ended. BUT a new one started. Ask your friend for a new referral code, and let’s try this again!',
        },
        otherSegment: {
          max: 'Come on, that’s too long to be real',
        },
        firstName: {
          required: 'First name is required',
          min: 'First name must be at least two letters',
          max: 'First name must be at most 30 letters',
          name: 'Contains invalid characters',
          regex: 'Contains invalid characters',
          tooLong: 'Please enter a shorter name',
        },
        lastName: {
          required: 'Last name is required',
          min: 'Last name must be at least two letters',
          max: 'Last name must be at most 30 letters',
          name: 'Contains invalid characters',
          regex: 'Contains invalid characters',
        },
        phoneNumber: {
          phoneNumber: 'Please enter a valid US number',
          regex: 'Please enter a valid phone number',
          exists: 'This phone number is already in use.',
          required: 'Phone number is required',
        },
        pinCode: {
          required: 'This isn’t the code we sent you. Can you check again?',
          regex: 'This isn’t the code we sent you. Can you check again?',
          length: 'This isn’t the code we sent you. Can you check again?',
          wrong: 'This isn’t the code we sent you. Can you check again?',
          pleaseWait: 'Please give the message at least 30 seconds to arrive',
          expired: 'Uh oh, your code expired. Let us send you a new one',
          locked:
            "Looks like you're having trouble remembering your password. Let's take a break, and you can try again in 5 minutes.",
        },
        password: {
          required:
            '8 characters or more with no repeating letters or sequence digits',
          min: '8 characters or more with no repeating letters or sequence digits',
          max: 'Up to 20 characters with no repeating letters or sequence digits',
          tooEasy: 'Password complexity too easy, add some spice',
          illegalNumeric:
            '8 characters or more with no repeating letters or sequence digits',
          noLowercase:
            '8 characters or more with no repeating letters or sequence digits',
          noUppercase:
            '8 characters or more with no repeating letters or sequence digits',
          noDigit:
            '8 characters or more with no repeating letters or sequence digits',
          noLetters:
            '8 characters or more with no repeating letters or sequence digits',
          noSpecial:
            '8 characters or more with no repeating letters or sequence digits',
          illegalKeyboard:
            '8 characters or more with no repeating letters or sequence digits',
          illegalAlpha:
            '8 characters or more with no repeating letters or sequence digits',
          passwordComplexity:
            '8 characters or more with no repeating letters or sequence digits',
        },
        ssn: {
          required: 'SSN is required',
          regex: 'SSN is required',
          invalidFormat: 'Please enter a valid SSN',
          length: 'Please enter a valid SSN',
          duplicate:
            "We're sorry, but we cannot open an account for you at this time.",
        },
        expirationDate: {
          inTheFuture: 'Please enter a valid expiration date',
        },
        birthDate: {
          date_format: 'Please enter a valid birth date',
          tooYoung: 'Sorry, but you have to be at least 18 to open an account',
          required: 'Birth date is required',
        },
        line1: {
          required: 'Address is required',
          min: 'Address must have at least 2 letters',
          max: 'Address must not be longer than 40 characters',
          invalidFormat: "We can't ship to a PO Box.",
          regex: 'Address contains invalid characters e.g: \' > % # " ; : / ,',
          invalidChars:
            'Message contains invalid characters e.g: \' > % # " ; : / ,',
        },
        line2: {
          required: 'Apartment is required',
          max: 'Address is too long',
        },
        city: {
          required: 'City is required',
          min: 'City is required',
          format: 'City contains invalid characters',
          max: 'City must not be longer than 20 characters',
        },
        state: {
          required: 'State is required',
        },
        postalCode: {
          required: 'Zip code is required',
          regex: 'Please enter a valid Zip code',
          invalidFormat: 'Please enter a valid Zip code',
          length: 'Zip code is required',
        },
        zipCode: {
          required: 'ZipCode is required',
        },
        checkbox: {
          invalidFormat: "We can't ship to a PO Box.",
          pleaseWait: 'Please try again in about 30 seconds',
          required:
            "We can't continue. To open a lili account, you have to accept the terms and conditions.",
          failedKyc: 'Please review all your details and try again',
          failedKycAddress:
            "We can't ship a card to a PO Box or a non residential address",
        },
        address: {
          required: 'Address is required',
          invalidFormat: 'Address format is incorrect',
          failedToParse: 'Sorry, you have to use a US address',
          failedKyc:
            'We’ve hit a snag. Please contact customer support to complete your account set-up at <a href="mailto:support@lili.co">support@lili.co</a>',
          notActive:
            'Hmm, this address isn’t active. Please provide a current address',
          notAccurate:
            'There are multiple locations with this address. Please provide more detail',
        },
        ownershipPercent: {
          min: 'UBO must have above 25 % ownership',
        },
      },
      attributes: {
        phoneNumber: 'Phone Number',
        pinCode: 'Pin code',
        address: 'Address',
      },
    },
    add_owner_ubo: {
      title: 'Do you want to grant account access to this owner?',
      button_yes: 'Yes',
      button_no: 'No',
      required: 'Selection is required',
      text_badge: 'Account Access',
    },
    submit: 'Continue',
    submit_new: 'Submit Your Application',
    letsGo: 'LET׳s GO',
    navBack: 'Back',
    skip: 'Skip',
    uboEnrollment: {
      pages: {
        intro: {
          mainTitle: 'Welcome to Lili,',
          subTitle: 'One platform for your business finances',
          disclaimer:
            '[PRIMARY_HOLDER_NAME] has invited you to join [LLC_NAME] business checking account',
          CTA: 'Get Started',
          footerContent:
            'Banking services provided by our partner Bank of Choice Financial\n' +
            '            Group Inc. Member FDIC.',
          errorTitle: 'Sorry, the invitation has expired',
          errorContent:
            'In order to keep your account safe, the invitation is available for 30 days. Please contact the your primary business account holder in order to get a new invitation.',
        },
        mfa: {
          mainTitle: 'let’s validate your phone number',
          subTitle: 'A verification code has been sent to',
          mfaError: "The digits entered don't match our records",
          resendCode: 'Resend code in:',
          linkContent: 'I didn’t get the verification code',
        },
        ssn: {
          mainTitle: 'Please enter the last 4 digits of your SSN',
          subTitle: 'This is necessary to verify your identity',
          ssnError: "The digits entered don't match our records",
        },
        password: {
          mainTitle: 'Great, now please choose a password',
          subTitle:
            '8 characters or more with at least one capital letter, one number and one special character',
        },
        complete: {
          mainTitle: 'Welcome to Lili,',
          subTitle: 'Your Lili Business Account is ready!',
          disclaimer:
            'Your Lili Visa Business Debit Card will be sent to the following address:',
          contact: 'Not your address? Contact us at support@lili.co',
          footerMainTitle: 'Your physical card is on the way',
          footerSubTitle:
            '<h4>We are printing your card. It should be delivered within <b> 2 weeks </b></h4>',
        },
      },
    },
  },
}

const i18nHandler = new VueI18n({
  locale: 'en',
  messages,
})

export default i18nHandler



// WEBPACK FOOTER //
// ./src/i18n/index.js